import script from "./tasks-index.vue?vue&type=script&setup=true&lang=js"
export * from "./tasks-index.vue?vue&type=script&setup=true&lang=js"

import "./tasks-index.vue?vue&type=style&index=0&id=3e90622c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e90622c"]])

export default __exports__